module.exports = __webpack_public_path__ + "img/express_collection.f7969972.png";